import { render, staticRenderFns } from "./media-upload.vue?vue&type=template&id=591c384b&scoped=true&"
import script from "./media-upload.vue?vue&type=script&lang=js&"
export * from "./media-upload.vue?vue&type=script&lang=js&"
import style0 from "./media-upload.vue?vue&type=style&index=0&id=591c384b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c384b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VRow})
